import { render, staticRenderFns } from "./Component2.vue?vue&type=template&id=74bd60ea&scoped=true&"
import script from "./Component2.vue?vue&type=script&lang=js&"
export * from "./Component2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd60ea",
  null
  
)

export default component.exports